<div class="home">
  <header class="header">
    <h1 class="title fancy-font">Evergreens</h1>
    <span class="subtitle">{{ 'home.subtitle' | translate }}</span>
    <div class="header-actions row">
      <a mat-icon-button routerLink="/about" [attr.aria-label]="'home.about' | translate" [title]="'home.about' | translate">
        <mat-icon>info</mat-icon>
      </a>
      <app-theme-toggle></app-theme-toggle>
    </div>
  </header>

  <h2 class="mat-headline-small section-title">{{ 'home.chooseMode' | translate }}</h2>

  <div class="mode-grid">
    <mat-card class="mode" appClickableCard>
      <div class="mode-header">
        <div class="mode-icon"><mat-icon>today</mat-icon></div>
        <div class="mode-heading">
          <h3>{{ 'home.modes.daily.title' | translate }}</h3>
          <span class="badge">{{ 'home.modes.daily.badge' | translate }}</span>
        </div>
      </div>
      <p>{{ 'home.modes.daily.description' | translate }}</p>
      <div class="daily-status row">
        @if (dailyFinished()) {
          <mat-icon>check_circle</mat-icon>
          <span>{{ 'home.modes.daily.played' | translate }}</span>
        }
        <span class="fill"></span>
        @if (dailyStreak() > 0) {
          <span class="streak"><mat-icon>local_fire_department</mat-icon>{{ dailyStreak() }}</span>
        }
      </div>
      <a mat-flat-button routerLink="/daily" cardAction>
        {{ (dailyFinished() ? 'home.modes.daily.result' : 'home.modes.daily.action') | translate }}
      </a>
    </mat-card>

    <mat-card class="mode" appClickableCard>
      <div class="mode-header">
        <div class="mode-icon"><mat-icon>tv</mat-icon></div>
        <div class="mode-heading">
          <h3>{{ 'home.modes.host.title' | translate }}</h3>
          <span class="badge">{{ 'home.modes.host.badge' | translate }}</span>
        </div>
      </div>
      <p>{{ 'home.modes.host.description' | translate }}</p>
      <a mat-flat-button routerLink="/host" cardAction>
        {{ 'home.modes.host.action' | translate }}
      </a>
    </mat-card>

    <mat-card class="mode" appClickableCard>
      <div class="mode-header">
        <div class="mode-icon"><mat-icon>public</mat-icon></div>
        <div class="mode-heading">
          <h3>{{ 'home.modes.online.title' | translate }}</h3>
          <span class="badge">{{ 'home.modes.online.badge' | translate }}</span>
        </div>
      </div>
      <p>{{ 'home.modes.online.description' | translate }}</p>
      <button mat-flat-button cardAction (click)="createLobby()" [disabled]="creating()">
        {{ 'home.modes.online.action' | translate }}
      </button>
    </mat-card>

    <mat-card class="mode" appClickableCard>
      <div class="mode-header">
        <div class="mode-icon"><mat-icon>login</mat-icon></div>
        <div class="mode-heading">
          <h3>{{ 'home.modes.join.title' | translate }}</h3>
          <span class="badge">{{ 'home.modes.join.badge' | translate }}</span>
        </div>
      </div>
      <p>{{ 'home.modes.join.description' | translate }}</p>
      <form class="join-form" (ngSubmit)="joinLobby()">
        <mat-form-field subscriptSizing="dynamic">
          <input matInput
                 cardAction
                 name="lobbyId"
                 [(ngModel)]="lobbyId"
                 [placeholder]="'home.modes.join.placeholder' | translate"
                 [attr.aria-label]="'home.modes.join.placeholder' | translate"
                 autocomplete="off"
                 autocapitalize="off"
                 spellcheck="false">
        </mat-form-field>
        <button mat-flat-button type="submit" [disabled]="!lobbyId().trim()">
          {{ 'common.join' | translate }}
        </button>
      </form>
    </mat-card>
  </div>

  <footer class="footer row">
    <a routerLink="/about">{{ 'home.about' | translate }}</a>
    <a routerLink="/legal/privacy">Privacy Policy</a>
    <a routerLink="/legal/imprint">Imprint</a>
  </footer>
</div>
